import axios from "../axios";
import { useLocation, useNavigate } from "react-router-dom";
import "../assets/styles/PaidUser.css";
import { useState, useEffect } from "react";
import logo from "../assets/images/swaasa-logo.png";

export default function PaidUser() {
  useEffect(() => {
    setTimeout(function () {
      if (localStorage.getItem("isTrial") == "true") {
        navigate("/trial-user");
      } else if (localStorage.getItem("isTrial") == "false") {
        navigate("/subscribed-user");
      }
    }, 0);
  }, []);

  useEffect(() => {
    getProfileApi();
    getPlansApi();
    // setTimeout( () => {
    // UserBalanceCountApi();
    // UserPaymentHistoryApi();
    // }, 3000)
  }, []);

  const [balance, setBalance] = useState("");
  const [phoneNumber, setPhoneNo] = useState("");
  const [userId, setUserId] = useState("");
  const navigate = useNavigate();
  const [balanceInfoArray, setBalanceInfoArray] = useState([]);
  const [lastArrayPurchasePlan, setlastArrayPurchasePlan] = useState("");
  const [lastArrayUpdatesOn, setlastArrayUpdatesOn] = useState("");
  const [lastArrayExpiry, setLastArrayExpiry] = useState("");
  const [plansArray, setPlansArray] = useState([]);
  var [payableAmount, setPayableAmount] = useState(0);
  var [totalAssessmentsCount, setTotalAssessmentsCount] = useState(0);
  var [loadMore, setLoadMore] = useState("false");
  var [selectedIndex, setSelectedIndex] = useState(-1);

  const loadMoreMethod = () => {
    setLoadMore("true");
  };

  const hideAll = () => {
    setLoadMore("false");
  };

  let [num, setNum] = useState(1);

  const incNum = (data, index) => {
    if (num < 4) {
      setNum(Number(num) + 1);
      setPayableAmount((num + 1) * data.plan_amount);
      setTotalAssessmentsCount(
        selectedIndex == index
          ? (num + 1) * data.assessment_count
          : data.assessment_count
      );
      console.log(totalAssessmentsCount);
    }
  };

  let decNum = (data, index) => {
    if (num > 1) {
      setNum(num - 1);
      setPayableAmount((num - 1) * data.plan_amount);
      setTotalAssessmentsCount(
        selectedIndex == index
          ? (num - 1) * data.assessment_count
          : data.assessment_count
      );
    } else if (num === 1) {
      setSelectedIndex(-1);
    }
  };

  let handleChange = (e) => {
    setNum(e.target.value);
  };

  const getProfileApi = () => {
    axios
      .get("/getProfile", {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "*",
          accessToken: localStorage.getItem("accessToken"),
        },
      })
      .then((response) => {
        setPhoneNo(response.data.data.contact);
        setUserId(response.data.data.loginId);
        localStorage.setItem("userName", response.data.data.firstname);
        const doctorId =
          response.data.data.loginId || localStorage.getItem("userId");
        UserBalanceCountApi(doctorId);
        UserPaymentHistoryApi(doctorId);
      });
  };

  const getPlansApi = () => {
    axios
      .get("/plans", {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "*",
          accessToken: localStorage.getItem("accessToken"),
        },
      })
      .then((response) => {
        console.log("Plans response: ", response);
        setPlansArray(response.data);
      });
  };

  // console.log(plansArray)

  const UserPaymentHistoryApi = (doctorId) => {
    const encodedUserId =
      typeof doctorId === "number"
        ? encodeURIComponent(String(doctorId))
        : encodeURIComponent(doctorId);
    axios
      .get(`/user_payment_history?doctorId=${encodedUserId}`, {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "*",
          accessToken: localStorage.getItem("accessToken"),
        },
      })
      .then((response) => {
        setBalanceInfoArray(response.data.balance_info);
        setlastArrayPurchasePlan(
          response.data.balance_info[response.data.balance_info.length - 1]
            .purchase_plan
        );
        setlastArrayUpdatesOn(
          response.data.balance_info[response.data.balance_info.length - 1]
            .updated_on
        );
        setLastArrayExpiry(
          response.data.balance_info[response.data.balance_info.length - 1]
            .expiry_date
        );

        console.log("balanceInfoArray Response: ", response);
      });
  };

  const addAssessmentsApi = (doctorId, totalAssessmentsCount) => {
    const encodedUserId =
      typeof doctorId === "number"
        ? encodeURIComponent(String(doctorId))
        : encodeURIComponent(doctorId);
    axios
      .post(
        `/add_assessments?doctorId=${encodedUserId}&assessments_funds=${totalAssessmentsCount}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "*",
            accessToken: localStorage.getItem("accessToken"),
          },
        }
      )
      .then((response) => {
        navigate("/PurchaseSuccess", {
          state: {
            showSuccessModal: true,
            assessmentLeft: response.data.available_balance,
            expiryDate: response.data.expiry_date,
            totalAssessments: totalAssessmentsCount,
          },
        });
      });
  };

  const UserBalanceCountApi = (doctorId) => {
    const encodedUserId =
      typeof doctorId === "number"
        ? encodeURIComponent(String(doctorId))
        : encodeURIComponent(doctorId);
    axios
      .get(`/user_balance_count?doctorId=${encodedUserId}`, {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "*",
          accessToken: localStorage.getItem("accessToken"),
        },
      })
      .then((response) => {
        setBalance(response.data.balance_info);
      });
  };

  // console.log(userId, 'user')

  const updatePaymentApi = (
    razorpayOrderId,
    razorpaySignature,
    razorpayPaymentId,
    userId,
    orderId
  ) => {
    let formData = {
      razorpay_order_id: razorpayOrderId,
      razorpay_signature: razorpaySignature,
      razorpay_payment_id: razorpayPaymentId,
      userId: userId,
      order_id: orderId,
    };

    axios
      .post(`/update_payment`, formData, {
        headers: {
          accessToken: localStorage.getItem("accessToken"),
        },
      })
      .then((response) => {
        return addAssessmentsApi(userId, totalAssessmentsCount);
      });
  };
  console.log(num);
  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  async function displayRazorpay() {
    console.log(num);
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );
    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    const result = await axios.post(
      "/payments/initiate_payment",
      {
        amount: parseInt(payableAmount) * 100,
        // // amount: (num * 500 + 500) * 100,
        // amount: 100,
        currency: "INR",
      },
      {
        headers: {
          accessToken: localStorage.getItem("accessToken"),
        },
      }
    );
    if (!result) {
      alert("Server error. Are you online?");
      return;
    }
    const { amount, id: order_id, currency } = result.data.data;
    const orderId = result.data.data.order_id;
    console.log("orderId: ", orderId);
    var options = {
      key: process.env.REACT_APP_RAZORPAY_CLIENT_ID, // Enter the Key ID generated from the Dashboard
      amount: amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
      currency: currency,
      name: "Swaasa",
      description: "Test Transaction",
      image: logo,
      order_id: orderId, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
      handler: function (response) {
        console.log("orderId: ", orderId);
        console.log("Response: ", response);
        console.log(
          "response.razorpay_payment_id: ",
          response.razorpay_payment_id
        );
        console.log("response.razorpay_order_id: ", response.razorpay_order_id);
        console.log(
          "response.razorpay_signature: ",
          response.razorpay_signature
        );
        if (
          response.razorpay_payment_id != null &&
          response.razorpay_order_id != null &&
          response.razorpay_signature != null
        ) {
          updatePaymentApi(
            response.razorpay_order_id,
            response.razorpay_signature,
            response.razorpay_payment_id,
            userId,
            orderId
          );
        }
      },
      prefill: {
        // name: "ABC",
        email: userId,
        contact: phoneNumber,
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#3399cc",
      },
    };
    var rzp1 = new window.Razorpay(options);
    rzp1.on("payment.failed", function (response) {
      // alert(response.error.code);
      // alert(response.error.description);
      // alert(response.error.source);
      // alert(response.error.step);
      // alert(response.error.reason);
      // alert(response.error.metadata.order_id);
      // alert(response.error.metadata.payment_id);
    });
    rzp1.open();
  }

  const formatDate = (dateString) => {
    if (!dateString) return "N/A"; // Return "N/A" if dateString is undefined or null
    const dateParts = dateString.split(" ");
    return dateParts.length > 0 ? dateParts[0] : "N/A"; // Return the first part of the date if available
  };

  return (
    <div className="PaidUser">
      <span className="PaidUser-Head-text">Welcome to Swaasa Subscription</span>
      <div className="PaidUser-boxes">
        <div
          className="PaidUser-boxes-balance-box"
          style={{
            height:
              loadMore === "true" && balanceInfoArray.length >= 8 
                ? "74vh"
                : "fit-content",
          }}
        >
          <span className="PaidUser-boxes-balance-box-banaceText">Balance</span>
          <span className="PaidUser-boxes-balance-box-banace">
            {balance}{" "}
            <span className="PaidUser-boxes-balance-box-assessmentsLeft">
              {balance > 1 ? "assessments" : "assessment"}
            </span>
          </span>

          <span className="PaidUser-boxes-balance-box-currentPlansText">
            Current Plans
          </span>
          {loadMore == "false" ? (
            <div className="PaidUser-boxes-balance-box-planBox">
              <span className="PaidUser-boxes-balance-box-planBox-head">
                {" "}
                <span className="PaidUser-boxes-balance-box-planBox-planText">
                  {lastArrayPurchasePlan}
                </span>
                <span className="PaidUser-boxes-balance-box-planBox-head-purchase">
                  <span className="purchase-date">Purchased Date: </span>{" "}
                  {lastArrayUpdatesOn.split(" ")[0]}
                </span>
              </span>
              {/* <span className="PaidUser-boxes-balance-box-planBox-subformoreassessments">
                - Subscribe to have access for more assessments.
              </span> */}
              <span className="PaidUser-boxes-balance-box-planBox-subformoreassessments">
                <span className="validFor1Year">- Valid for 1 year</span>
                <span className="PaidUser-boxes-balance-box-planBox-head-purchase">
                  <span className="purchase-date">Expiry Date: </span>{" "}
                  {lastArrayExpiry.split(" ")[0]}
                </span>
              </span>
            </div>
          ) : (
            ""
          )}
          {loadMore === "false" && balanceInfoArray.length > 1 ? (
            <span
              style={{
                fontSize: "16px",
                fontWeight: "600",
                display: "flex",
                gap: "5px",
                alignItems: "center",
                margin: "8px",
                cursor: "pointer",
                width: "fit-content",
                marginLeft: "auto",
                marginRight: "auto",
              }}
              onClick={loadMoreMethod}
            >
              Show all
            </span>
          ) : (
            ""
          )}

          <div style={{ gap: "20px", display: "grid" }}>
            {loadMore == "true" ? (
              balanceInfoArray.map((data, i) => {
                return (
                  <div className="PaidUser-boxes-balance-box-planBox">
                    <span className="PaidUser-boxes-balance-box-planBox-head">
                      <span className="PaidUser-boxes-balance-box-planBox-planText">
                        {data.purchase_plan}
                      </span>
                      <span className="PaidUser-boxes-balance-box-planBox-head-purchase">
                        <span
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                          }}
                        >
                          Purchased Date:{" "}
                        </span>{" "}
                        {data.updated_on.split(" ")[0]}
                      </span>
                    </span>

                    {/* <span className="PaidUser-boxes-balance-box-planBox-subformoreassessments">
                      - Subscribe to have access for more assessments.
                    </span> */}
                    <span className="PaidUser-boxes-balance-box-planBox-subformoreassessments">
                      <span className="validFor1Year">- Valid for 1 year</span>
                      <span className="PaidUser-boxes-balance-box-planBox-head-purchase">
                        <span
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                          }}
                        >
                          Expiry Date:{" "}
                        </span>{" "}
                        {formatDate(data?.expiry_date)}
                      </span>
                    </span>
                  </div>
                );
              })
            ) : (
              <div></div>
            )}
          </div>
          {loadMore == "true" ? (
            <span
              style={{
                fontSize: "16px",
                fontWeight: "600",
                display: "flex",
                gap: "5px",
                alignItems: "center",
                margin: "8px",
                cursor: "pointer",
                width: "fit-content",
                marginLeft: "auto",
                marginRight: "auto",
              }}
              onClick={hideAll}
            >
              Hide all
            </span>
          ) : (
            ""
          )}
        </div>
        <div style={{height:'fit-content'}}> 
        <div className="PaidUser-boxes-purchase-box">
          <span className="PaidUser-boxes-purchase-box-purchaseText">
            Purchase
          </span>
          {plansArray.map((data, index) => {
            return (
              <div>
                <div
                  className={
                    selectedIndex == index
                      ? "PaidUser-boxes-purchase-box-subscriptionBox--selected"
                      : "PaidUser-boxes-purchase-box-subscriptionBox"
                  }
                  onClick={() => {}}
                >
                  <span className="PaidUser-boxes-purchase-box-subscriptionBox-top-up-text">
                    Top-up
                  </span>
                  <div className="assessments-amount-payable">
                    <div>
                      <span className="-INR">{data.plan_name}</span>
                      <br></br>
                      <span className="-Assessments-Valid-for-1-year">
                        <span className="text-style-1">
                          {/* {data.assessment_count}  */}
                          {selectedIndex == index
                            ? num * data.assessment_count
                            : data.assessment_count}
                          Assessments
                        </span>
                        <br></br>
                        <span class="year-valid"> Valid for 1 year</span>
                      </span>
                    </div>
                    <div className="increment-decrement-box">
                      <div className="increment-decrement">
                        {selectedIndex == index ? (
                          <span className="">
                            <span onClick={() => decNum(data, index)}> - </span>
                            <span
                              id="number"
                              value={num}
                              onChange={handleChange}
                            >
                              {num}
                            </span>
                            <span onClick={() => incNum(data, index)}> + </span>
                          </span>
                        ) : (
                          <span
                            onClick={() => {
                              setSelectedIndex(index);
                              setNum(1);
                              setPayableAmount(num * data.plan_amount);
                              setTotalAssessmentsCount(
                                selectedIndex == index
                                  ? num * data.assessment_count
                                  : data.assessment_count
                              );
                            }}
                          >
                            Select
                          </span>
                        )}
                      </div>
                      <div>
                        <span className="Amount-Payable">Amount Payable</span>
                        <br></br>
                        <span className="-INR">
                          <span style={{ fontFamily: "math" }}>₹</span>{" "}
                          {selectedIndex == index
                            ? num * data.plan_amount
                            : data.plan_amount}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          {/* Dynamic Plans implementation end*/}

          {selectedIndex != -1 ? (
            <span
              onClick={displayRazorpay}
              className="PaidUser-boxes-purchase-box-makePaymentBtn"
            >
              Make Payment &#8594;
            </span>
          ) : (
            ""
          )}
        </div></div>
       
      </div>
    </div>
  );
}
